import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-gray-900 font-openSans" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "pt-5 pb-3 m-1" }
const _hoisted_4 = { class: "flex flex-row text-sm md:text-base xl:text-lg" }
const _hoisted_5 = { class: "flex items-center justify-center w-2/12" }
const _hoisted_6 = {
  key: 2,
  class: "mt-2 -mb-5 text-xs font-semibold text-center text-nominee-danger lg:-mb-7 sm:text-sm"
}
const _hoisted_7 = { class: "flex flex-col m-auto mt-1 text-xs text-center sm:flex-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "pr-1 text-gray-900" }, "I remembered my password. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NTitle = _resolveComponent("NTitle")!
  const _component_NSwitch = _resolveComponent("NSwitch")!
  const _component_NFormInput = _resolveComponent("NFormInput")!
  const _component_NFormButton = _resolveComponent("NFormButton")!
  const _component_FormSuccsess = _resolveComponent("FormSuccsess")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.requestSuccsess)
      ? (_openBlock(), _createBlock(_component_NTitle, {
          key: 0,
          class: "mb-2 text-2xl sm:mb-6 sm:text-3xl",
          tag: "h2",
          content: "Reset password"
        }))
      : _createCommentVNode("", true),
    (!_ctx.requestSuccsess)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_2))
      : _createCommentVNode("", true),
    (!_ctx.requestSuccsess)
      ? (_openBlock(), _createElementBlock("form", {
          key: 2,
          class: "flex flex-col px-3 pt-4 pb-3 sm:pb-4 sm:pt-4 md:px-3 md:pb-6 lg:px-3 md:pt-5",
          onKeyup: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["enter"])),
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass([{
              'text-gray-900 font-semibold border-gray-900': !_ctx.useUsername,
            }, "flex items-center justify-center w-5/12 px-1 py-1 rounded-md cursor-pointer select-none border-1 text-md lg:text-base"]),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emailButtonClick && _ctx.emailButtonClick(...args)))
              }, " Email ", 2),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_NSwitch, {
                  modelValue: _ctx.useUsername,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.useUsername) = $event)),
                  onClick: _ctx.resetAllErrors
                }, null, 8, ["modelValue", "onClick"])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass([{
              'text-gray-900 font-semibold border-gray-900': _ctx.useUsername,
            }, "flex items-center justify-center w-5/12 px-1 py-1 border-gray-400 rounded-md cursor-pointer select-none border-1 text-md lg:text-base"]),
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.usernameButtonClick && _ctx.usernameButtonClick(...args)))
              }, " Username ", 2)
            ])
          ]),
          (_ctx.useUsername)
            ? (_openBlock(), _createBlock(_component_NFormInput, {
                key: 0,
                modelValue: _ctx.usernameInput,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.usernameInput) = $event)),
                class: "",
                type: "text",
                error: _ctx.usernameStatus.message,
                placeholder: "Username",
                onInputChanged: _ctx.resetUsernameStatus
              }, null, 8, ["modelValue", "error", "onInputChanged"]))
            : _createCommentVNode("", true),
          (!_ctx.useUsername)
            ? (_openBlock(), _createBlock(_component_NFormInput, {
                key: 1,
                modelValue: _ctx.emailInput,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.emailInput) = $event)),
                class: "",
                type: "text",
                error: _ctx.emailStatus.message,
                placeholder: "example@mail.com",
                onInputChanged: _ctx.resetEmailStatus
              }, null, 8, ["modelValue", "error", "onInputChanged"]))
            : _createCommentVNode("", true),
          (_ctx.resetPasswordResponseError.detail != '')
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.resetPasswordResponseError.detail), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_NFormButton, {
            disabled: (!_ctx.usernameStatus.valid && !_ctx.emailStatus.valid) || _ctx.isProcessingRequest,
            type: "submit",
            class: "w-full h-10 mt-8 lg:mt-10 sm:h-12",
            name: "Reset Password",
            loading: _ctx.isProcessingRequest,
            onClick: _ctx.submitForm
          }, null, 8, ["disabled", "loading", "onClick"]),
          _createElementVNode("p", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", {
              class: "font-bold text-black cursor-pointer",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goToLogin && _ctx.goToLogin(...args)))
            }, "Take me to Login!")
          ])
        ], 32))
      : _createCommentVNode("", true),
    _createVNode(_component_FormSuccsess, {
      "button-name": "Ok",
      title: "Reset email sent!",
      message: "Check your inbox and follow instructions to reset your password.",
      "show-succsess": _ctx.requestSuccsess,
      onButtonClick: _ctx.closeModal
    }, null, 8, ["show-succsess", "onButtonClick"])
  ]))
}